import request from '@/request/utils/newrequest.js'
import baseUrl from '@/request/base.js'
import { baseconfig, rsaBasicModuleConfig } from '@/config.js'
import { httpRequest } from '@/request/utils/httprequest.js'
import { rsa } from '@/tools/encrypt.js'
import { publicFun } from '@/tools/time.js'
import store from '@/store'
import qs from 'qs'

//受理登记列表--CGX
export const acceptApplyModule = {
    // 受理登记列表--CGX
    async acceptApplyList(page,page_size,key_words,id_number,policy_measure_id,account_nature,year,accept_region_level,accept_region_id,audit_status,apply_type) {
        const adminToken = store.getters.adminID
        var paras = {
            page:page,
            page_size:page_size,
            key_words:key_words,
            id_number:id_number,
            policy_measure_id:policy_measure_id,
            account_nature:account_nature,
            year: year,
            accept_region_level: accept_region_level,
            accept_region_id: accept_region_id,
            audit_status: audit_status,
            apply_type: apply_type,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + policy_measure_id + year + accept_region_id + "fasjkfjd", rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/acceptapplylist",
            method: 'get',
            params: paras
        })
    },
    // 申报受理/申报编辑/扶助编辑
    async policydeclarationinfo(applyhousejson, applyuserjson, applyusergalleryjson, policy_measure_id, type, mark, original_value_json,apply_record_id) {
        const adminToken = store.getters.adminID
        var paras = {
            applyhousejson: applyhousejson,
            applyuserjson: applyuserjson,
            applyusergalleryjson: applyusergalleryjson,
            policy_measure_id: policy_measure_id,
            type: type,
            mark: mark,
            original_value_json: original_value_json,
            apply_record_id:apply_record_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + policy_measure_id + type + 'dasdfe', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/policydeclarationinfo",
            method: 'put',
            data: qs.stringify(paras)
        })
    },
    // 根据政策身份证查询申报信息
    async queryreportinfo(certificate_no, policy_measure_id) {
        const adminToken = store.getters.adminID
        var paras = {
            certificate_no: certificate_no,
            policy_measure_id: policy_measure_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + '~165asDI9', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/queryreportinfo",
            method: 'get',
            params: paras
        })
    },
    // 查看资料信息
    async querydatainfo(record_id, mark) {
        const adminToken = store.getters.adminID
        var paras = {
            record_id: record_id,
            mark: mark,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + record_id + '~1613ASDI9', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/querydatainfo",
            method: 'get',
            params: paras
        })
    },


    // 申报审核-批量审核--CGX
    async applybatchaudit(apply_record_ids, user_ids, policy_measure_id, action, approve_opinion_id, approve_opinion,curr_node_ids) {
        const adminToken = store.getters.adminID
        var paras = {
            apply_record_ids: apply_record_ids,
            user_ids: user_ids,
            policy_measure_id: policy_measure_id,
            action: action,
            approve_opinion_id: approve_opinion_id,
            approve_opinion: approve_opinion,
            curr_node_ids:curr_node_ids,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + apply_record_ids + user_ids + policy_measure_id + action + 'sdajfkj', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/applybatchaudit",
            method: 'post',
            data: qs.stringify(paras)
        })
    },

    // 获取审核记录列表 CGF
    async applyauditrecordlist(applyrecordId) {
        const adminToken = store.getters.adminID
        var paras = {
            applyrecord_id: applyrecordId,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + 'qwerxyz', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/applyauditrecordlist",
            method: 'get',
            params: paras
        })
    },
    // 获取年审记录列表 CGF
    async yearauditrecordList(applyrecordId) {
        const adminToken = store.getters.adminID
        var paras = {
            reward_record_id: applyrecordId,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + 'qwerasdf', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/yearauditrecordList",
            method: 'get',
            params: paras
        })
    },

    // 获取审核状态列表--CGX
    async acccptauditstatuslist(policy_measure_id) {
        const adminToken = store.getters.adminID
        var paras = {
            policy_measure_id: policy_measure_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + policy_measure_id + 'dfsmkfjs', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/acccptauditstatuslist",
            method: 'get',
            params: paras
        })
    },


    // 申报完成-导出审批表
    async exportapplyform(key_words,id_number,policy_measure_id,account_nature,year,enjoy_census_region_level,enjoy_census_region_id,current_census_region_level,current_census_region_id,node_status_str) {
        const adminToken = store.getters.adminID
        var paras = {
            key_words: key_words,
            id_number: id_number,
            policy_measure_id: policy_measure_id,
            account_nature: account_nature,
            year: year,
            enjoy_census_region_level: enjoy_census_region_level,
            enjoy_census_region_id: enjoy_census_region_id,
            current_census_region_level:current_census_region_level,
            current_census_region_id:current_census_region_id,
            node_status_str: node_status_str,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + '~cv1QYXCRIPi', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/exportapplyform",
            method: 'get',
            params: paras
        })
    },

    // 受理登记删除 --CGX
    async deleteacceptinfo(apply_record_id,policy_measure_id) {
        const adminToken = store.getters.adminID
        var paras = {
            apply_record_id: apply_record_id,
            policy_measure_id: policy_measure_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + apply_record_id + 'dfnskdfn', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/deleteacceptinfo",
            method: 'post',
            data: qs.stringify(paras)
        })
    },
}

//年审
export const annualReviewModule = {
    // 年审审核-扶助对象列表 --JMF
    async rewardannualreviewuserlist( page, page_size,  key_words, id_number, policy_measure_id, year, enjoy_census_region_level, enjoy_census_region_id, audit_status,operator_region_level,living_auth_status) {
        const adminToken = store.getters.adminID
        var pares = {
            page,
            page_size,
            key_words,
            id_number,
            policy_measure_id,
            year,
            enjoy_census_region_level,
            enjoy_census_region_id,
            audit_status,
            operator_region_level,
            living_auth_status,
            timestamp:rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign:rsa.signString(baseconfig.v + adminToken + policy_measure_id + year + enjoy_census_region_id + "sfma#dsfkdfjnj", rsaBasicModuleConfig.clientPrivateKey)
        }
        return await request({
            url: baseUrl.basic + "v2/rewardannualreviewuserlist",
            method: 'get',
            params: pares
        })
    },

    // 年审审核-批量审核--JMF
    async rewardannualreviewbatchaudit(apply_record_ids, user_ids, policy_measure_ids, is_audit_pass, no_pass_reason_id, audit_year, audit_time, audit_comment,mark) {
        const adminToken = store.getters.adminID
        var paras = {
            apply_record_ids: apply_record_ids,
            user_ids: user_ids,
            policy_measure_ids: policy_measure_ids,
            is_audit_pass: is_audit_pass,
            no_pass_reason_id: no_pass_reason_id,
            audit_year: audit_year,
            audit_time: audit_time,
            audit_comment: audit_comment,
            mark:mark,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + apply_record_ids + user_ids + policy_measure_ids + is_audit_pass + no_pass_reason_id + 'DFjdfs$sd9hj', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/rewardannualreviewbatchaudit",
            method: 'post',
            data: qs.stringify(paras)
        })
    },
    // 年审-获取审核状态列表--CGX
    async awardauditstatuslist(policy_measure_id) {
        const adminToken = store.getters.adminID
        var paras = {
            policy_measure_id: policy_measure_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + policy_measure_id + 'dfsmkfjs', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/awardauditstatuslist",
            method: 'get',
            params: paras
        })
    },
    //撤销年审
    async revokerewardannualreview(reward_record_id,policy_measure_id,audit_year) {
        const adminToken = store.getters.adminID
        var paras = {
            reward_record_id: reward_record_id,
            policy_measure_id: policy_measure_id,
            audit_year: audit_year,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + reward_record_id + '~AS651324', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/revokerewardannualreview",
            method: 'post',
            data: qs.stringify(paras)
        })
    },
    
}
//公示
export const publicityModule = {
    // 获取公示列表--dgf
    async applyaudituserlist(page, page_size, key_words, id_number, policy_measure_id, region_level, region_id, publicity_end_time, node_status_str, operator_region_level) {
        const adminToken = store.getters.adminID
        var paras = {
            page: page,
            page_size: page_size,
            key_words: key_words,
            id_number: id_number,
            policy_measure_id: policy_measure_id,
            region_level: region_level,
            region_id: region_id,
            publicity_end_time: publicity_end_time,
            node_status_str: node_status_str,
            operator_region_level: operator_region_level,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + policy_measure_id + region_level + region_id + 'dfsmkfj', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/applyaudituserlist",
            method: 'get',
            params: paras
        })
    },
    // 获取政策公示状态列表--dgf
    async publicstatuslist(policy_measure_id) {
        const adminToken = store.getters.adminID
        var paras = {
            policy_measure_id: policy_measure_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + policy_measure_id + 'dfsmkfjs', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/publicstatuslist",
            method: 'get',
            params: paras
        })
    },
    
    // 公示图集列表 dgf
    async applypublicitygalleryinfolist(page, pagesize, apply_record_id,gallery_type) {
        const adminToken = store.getters.adminID
        var paras = {
            page: page,
            pagesize: pagesize,
            apply_record_id: apply_record_id,
            gallery_type: gallery_type,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken  + '~A6564d', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/applypublicitygalleryinfolist",
            method: 'get',
            params: paras
        })
    },

    // 批量修改公示状态--dgf
    async applybatcheditpublicitystatus(apply_record_ids, user_ids,policy_measure_id , gallery_json,publicity_status) {
        const adminToken = store.getters.adminID
        var paras = {
            apply_record_ids: apply_record_ids,
            user_ids: user_ids,
            gallery_json: gallery_json,
            policy_measure_id: policy_measure_id,
            publicity_status:publicity_status,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + apply_record_ids + user_ids + policy_measure_id + publicity_status + 'dfsnkj', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/applybatcheditpublicitystatus",
            method: 'post',
            data: qs.stringify(paras)
        })
    },

    // 申报审核-批量审核--CGX
    async applybatchaudit(apply_record_ids, user_ids, policy_measure_id, action, approve_opinion_id, approve_opinion,curr_node_ids) {
        const adminToken = store.getters.adminID
        var paras = {
            apply_record_ids: apply_record_ids,
            user_ids: user_ids,
            policy_measure_id: policy_measure_id,
            action: action,
            approve_opinion_id: approve_opinion_id,
            approve_opinion: approve_opinion,
            curr_node_ids:curr_node_ids,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + apply_record_ids + user_ids + policy_measure_id + action + 'sdajfkj', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/applybatchaudit",
            method: 'post',
            data: qs.stringify(paras)
        })
    },

}

// 迁出
export const moveoutrewardrecordinfolistModel = {
    // 迁出管理-迁出列表 --JMF
    async moveoutrewardrecord(page, pagesize, key_words, id_number, enjoy_census_region_level, enjoy_census_region_id, policy_measure_id,region_match_type,enjoy_status) {
        const adminToken = store.getters.adminID
        var paras = {
            page,
            pagesize,
            key_words,
            id_number,
            enjoy_census_region_level,
            enjoy_census_region_id,
            policy_measure_id,
            region_match_type,
            enjoy_status,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + policy_measure_id + '~34Casdfgd4d', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/moveoutrewardrecord",
            method: 'get',
            params: paras
        })
    },

    // 迁出管理-迁出/区域调整 --JMF
    async rewardcensuschangesapply(reward_record_ids, policy_measure_ids, reward_user_ids, old_census_region_id, new_census_region_id, move_out_type) {
        const adminToken = store.getters.adminID
        var paras = {
            policy_measure_ids: policy_measure_ids,
            reward_user_ids: reward_user_ids,
            reward_record_ids: reward_record_ids,
            old_census_region_id: old_census_region_id,
            new_census_region_id: new_census_region_id,
            move_out_type: move_out_type,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(reward_record_ids) + String(policy_measure_ids) + String(reward_user_ids) + String(old_census_region_id) + String(new_census_region_id) + String(move_out_type) + 'df9sdj^f5smk', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/rewardcensuschangesapply",
            method: 'post',
            data: qs.stringify(paras)
        })
    },

    // 迁出管理-迁出查询
    async moveoutqueryrecord(page, pagesize, key_words,id_number ,year, audit_status, enjoy_census_region_level, enjoy_census_region_id,policy_measure_id) {
        const adminToken = store.getters.adminID
        var paras = {
            page:page,
            pagesize:pagesize,
            key_words:key_words,
            id_number:id_number,
            year:year,
            audit_status:audit_status,
            enjoy_census_region_level:enjoy_census_region_level,
            enjoy_census_region_id:enjoy_census_region_id,
            policy_measure_id:policy_measure_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + policy_measure_id + 'dlv9GL~3sd4neld', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/moveoutqueryrecord",
            method: 'get',
            params: paras
        })
    },

}

// 迁入
export const moveinrewardrecordinfolistModel = {


    // 迁入管理-迁入列表 --JMF
    async moveinrewardrecord(page, pagesize, key_words,id_number ,year, audit_status, enjoy_census_region_level, enjoy_census_region_id,policy_measure_id) {
        const adminToken = store.getters.adminID
        var paras = {
            page:page,
            pagesize:pagesize,
            key_words:key_words,
            id_number:id_number,
            year:year,
            audit_status:audit_status,
            enjoy_census_region_level:enjoy_census_region_level,
            enjoy_census_region_id:enjoy_census_region_id,
            policy_measure_id:policy_measure_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + policy_measure_id + 'dlv9GL~3sd4neld', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/moveinrewardrecord",
            method: 'get',
            params: paras
        })
    },


    // 迁入管理-受理审核--HYT
    async rewardcensuschangesaudit(census_changes_record_ids, audit_status, no_pass_reason_id, no_pass_reason) {
        const adminToken = store.getters.adminID
        var paras = {
            census_changes_record_ids: census_changes_record_ids,
            audit_status: audit_status,
            no_pass_reason_id: no_pass_reason_id,
            no_pass_reason: no_pass_reason,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(census_changes_record_ids) + String(audit_status) + 'SAjh*8djDF11', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/rewardcensuschangesaudit",
            method: 'post',
            data: qs.stringify(paras)
        })
    },
}



//扶助对象
export const rewardRecordModule = {
    // 扶助对象列表 --JMF
    async rewardrecordinfolist(page, pagesize, key_words, id_number, enjoy_status, apply_class, policy_measure_id, year, enjoy_census_region_level, enjoy_census_region_id) {
        const adminToken = store.getters.adminID
        var paras = {
            page,
            pagesize,
            key_words,
            id_number,
            enjoy_status,
            apply_class,
            policy_measure_id,
            year,
            enjoy_census_region_level,
            enjoy_census_region_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + page + year + "ds9h~34CgnFD4d", rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/rewardrecordinfolist",
            method: 'get',
            params: paras
        })

    },
    //扶助对象退出/恢复 --CGX
    async awardenjoystatusedit(reward_record_id, is_person_logout, person_logout_reason_id, person_logout_reason_remark, census_emigration_place,audit_year,audit_time) {
        const adminToken = store.getters.adminID
        var paras = {
            reward_record_id: reward_record_id,
            is_person_logout: is_person_logout,
            person_logout_reason_id: person_logout_reason_id,
            person_logout_reason_remark: person_logout_reason_remark,
            census_emigration_place: census_emigration_place,
            audit_year:audit_year,
            audit_time:audit_time,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(reward_record_id) + '~AS651324', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/awardenjoystatusedit",
            method: 'post',
            data: qs.stringify(paras)
        })
    },

    // 申报受理
    async awardadd(applyhousejson, applyuserjson, applyusergalleryjson, policy_measure_id) {
        const adminToken = store.getters.adminID
        var paras = {
            applyhousejson: applyhousejson,
            applyuserjson: applyuserjson,
            applyusergalleryjson: applyusergalleryjson,
            policy_measure_id: policy_measure_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + policy_measure_id + 'dasdfe', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/awardadd",
            method: 'put',
            data: qs.stringify(paras)
        })
    },

    // 扶助对象编辑
    async awardedit(applyhousejson, applyuserjson, applyusergalleryjson, reward_record_id) {
        const adminToken = store.getters.adminID
        var paras = {
            applyhousejson: applyhousejson,
            applyuserjson: applyuserjson,
            applyusergalleryjson: applyusergalleryjson,
            reward_record_id: reward_record_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + reward_record_id + 'dfjskdf', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/awardedit",
            method: 'put',
            data: qs.stringify(paras)
        })
    },

    // 根据政策身份证查询存档非扶助对象数据
    async queryrewardnoenjoylist(certificate_no, policy_measure_id) {
        const adminToken = store.getters.adminID
        var paras = {
            certificate_no,
            policy_measure_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + "~165asDI9", rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/queryrewardnoenjoylist",
            method: 'get',
            params: paras
        })
    },

    // 根据政策身份证查询存档非扶助对象数据
    async queryrewardnoenjoyinfo(certificate_no,reward_house_id, policy_measure_id) {
        const adminToken = store.getters.adminID
        var paras = {
            certificate_no,
            policy_measure_id,
            reward_house_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + policy_measure_id + "~1613ASDI9", rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/queryrewardnoenjoyinfo",
            method: 'get',
            params: paras
        })
    },

    //修改证件信息
    async awardeditcertno(reward_record_id,certificate_type, certificate_no,sex_id,user_birthday) {
        const adminToken = store.getters.adminID
        var paras = {
            reward_record_id,
            certificate_type,
            certificate_no,
            sex_id,
            user_birthday,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + reward_record_id + "dfjskdf", rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/awardeditcertno",
            method: 'put',
            data: qs.stringify(paras)
        })
    },

    // 扶助对象删除 --CGX
    async deleterewardinfo(reward_record_id,policy_measure_id) {
        const adminToken = store.getters.adminID
        var paras = {
            reward_record_id: reward_record_id,
            policy_measure_id: policy_measure_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + reward_record_id + 'dfnskdfn', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await request({
            url: baseUrl.basic + "v2/deleterewardinfo",
            method: 'post',
            data: qs.stringify(paras)
        })
    },

        // 扶助对象到处
        async exportrewardexcel(mark,page,page_size,key_words,id_number,enjoy_status,apply_class,policy_measure_id,year,enjoy_census_region_level,enjoy_census_region_id) {
            const adminToken = store.getters.adminID
            var paras = {
                mark,
                page,
                page_size,
                key_words,
                id_number,
                enjoy_status,
                apply_class,
                policy_measure_id,
                year,
                enjoy_census_region_level,
                enjoy_census_region_id,
                timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
                _sign: rsa.signString(baseconfig.v + adminToken + "~cv1QYXCRIPi", rsaBasicModuleConfig.clientPrivateKey),
            }
            return await request({
                url: baseUrl.basic + "v2/exportrewardexcel",
                method: 'get',
                params: paras
            })
        },

}